import {inject, observer} from "mobx-react";
import CoworkRichText from '../../../public/CoworkRichText';
import {toJS} from 'mobx';
import isFunction from 'lodash/isFunction';
import {WeaTop, WeaTab, WeaNewScroll, WeaCheckbox, WeaAlertPage, WeaSearchGroup, WeaTools, WeaInput,WeaFormItem, WeaLocaleProvider} from 'ecCom';
import { WeaSwitch } from 'comsMobx';
import {Button, Pagination, message, Spin, Modal, Form, DatePicker} from 'antd';
const getLabel = WeaLocaleProvider.getLabel;

import LogDialog from '../dialog/CoworkLogDialog'
import Resource from './Resource';
import CoworkFloorDialog from '../dialog/CoworkFloorDialog';
import NewCowork from '../dialog/NewCowork';
import Detail from './Detail';
import ReplyList from './ReplyList';
import MyReplyList from './MyReplyList';
import Stat from './Stat';
const storeMapKey = 2; //当前页面回去 新建编辑协作 store的key
const { viewer } = WeaTools;

class SearchForm extends React.Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    this.props.initFunc && this.props.initFunc(this);
  }
  
  render() {
    const {conditioninfo = [], form} = this.props;
    let group = [];
    if (form.isFormInit) {
      conditioninfo.map((c) => {
        let items = [];
        c.items.map(fields => {
          items.push({
            com: (
              <WeaFormItem
                label={`${fields.label}`}
                labelCol={{span: `${fields.labelcol}`}}
                wrapperCol={{span: `${fields.fieldcol}`}}
              >
                <WeaSwitch fieldConfig={fields} form={form}/>
              </WeaFormItem>
            ),
            colSpan: 1
          })
        });
        group.push(<WeaSearchGroup needTigger={true} title={c.title} showGroup={c.defaultshow} items={items}/>)
      });
    }
    return <div>{group}</div>;
  }
  
  clear = () => {
    this.props.form.resetConditionValue();
  }
}

@inject("coworkMainStore","coworkStoreMap")
@observer
class CoworkContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // showSearchAd: false,
      // tabKey: 'list',
      // page: {
      //   current: 1,
      //   total: 0,
      //   showQuickJumper: true
      // },
      // edit: false,//编辑状态
      visiable: false, //log
      value: '1',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.coworkId !== this.props.coworkId) {
      this.props.coworkMainStore.initDetailParams();
      // this.setState({
      //   tabKey: 'list',
      //   edit: false
      // });
    }
    if (nextProps.coworkId != this.props.coworkId) {
      this.scrollToTop();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    jQuery(document).off("keydown", "", this.onKeyDown)
      .on("keydown", "", this.onKeyDown);
    // if (prevProps.coworkId != this.props.coworkId) {
    //   this.scrollToTop();
    // }
    this.setContent();
  }
  
  onImgs = (arr) => {
    Array.from(arr).forEach((img, index) => {
      img.onload = () => {
        img.setAttribute('data-imgsrc', img.src);
        img.setAttribute('class', 'formImgPlay');
        img.onclick = viewer; 
      }
    });
  }

  setContent = () => {
    let content_img = document.querySelectorAll('.cowork-content-text-main img'); // 详情内容中的img
    let list_img = document.querySelectorAll('.cowork-reply-remark .wea-cl-content img'); // 交流列表中的img
    this.onImgs(content_img)
    this.onImgs(list_img)
  }

  //待优化
  handleScroll=()=>{
    if(this.refs.scroll.getScrollTop()>0){
      this.refs.shadow.style.zIndex='1';
      this.refs.shadow.style.position='relative';
      this.refs.shadow.style.boxShadow = '0 5px 5px 0 rgba(0,0,0,0.02)';
      this.refs.shadow.style.webkitBoxShadow = '0 5px 5px 0 rgba(0,0,0,0.02)';
    }else if(this.refs.scroll.getScrollTop()==0){
      this.refs.shadow.style.zIndex='';
      this.refs.shadow.style.position='';
      this.refs.shadow.style.boxShadow = '';
      this.refs.shadow.style.webkitBoxShadow = '';
    }
  }
  
  render() {
    const {coworkMainStore} = this.props;
    let {content, config, operateCoworkItem, markItemAsType, deleteCoworkLabels, detailParams} = coworkMainStore;
    const {searchForm} = content;
    content = toJS(content);
    config = toJS(config);

    let {discussSearch = {}} = config, {conditioninfo = []} = discussSearch;
    let {page, checkAll, batchOperate, pendApprove} = content;
    let con = content.cowork, itemsVO =  (con && con.itemsVO) || {}, {status} = itemsVO,
      coworkContentId = content.id, labelList = config.labelList, {coworkBaseSettingMap = {}} = con || {};
    let {coworkstate} = coworkBaseSettingMap;
    let {srchcontent} = searchForm.getFormParams();
    let canReply = status != '2' || coworkstate == '1';//协作不是结束状态，或者结束状态也能回复，此时可以发表交流或评论。
    const {showSearchAd, tabKey, edit} = detailParams;

    if (itemsVO && itemsVO.approvalAtatus == '1' && con && (con.canApproval).toString() !== '1') {
      return (
        <div className={`wea-cowork-content ` + ((tabKey == 'list' || tabKey == 'my') && 'cowork-list-scroll')}>
          <WeaAlertPage>
            <div>
              <h1 style={{color: 'red'}}>该协作正处于待审批状态</h1>
              <h3>您不是协作管理员，暂无权限查看</h3>
            </div>
          </WeaAlertPage>
        </div>
      )
    }

    return (
      <div className={`wea-cowork-content ` + ((tabKey == 'list' || tabKey == 'my') && 'cowork-list-scroll')}>
        {content.loading ? (
          <div className="wea-cowork-con">
            <Spin className="cowork-con-spin" size="large"/>
          </div>
        ) : (
          (con && con.viewRight == 1) ? (
            [
              <div style={{height: '100%'}}>
                <div ref='shadow' className='cowork-content-detail wea-f14'>
                  <span className='cowork-content-detail-text wea-f14'>{getLabel(382645, '协作详情')}</span>
                  <div>
                    {
                      con.canEdit && con.canEdit == 1 ?
                        <Button className="cowork-content-detail-btn" onClick={() => this.edit()}>{getLabel(93, '编辑')}</Button> : null
                    }
                    {
                      con.canEdit && con.canEdit == 1 && con.itemsVO.status == '2' ?
                        <Button className="cowork-content-detail-btn" onClick={this.operateCoworkItem.bind(this, coworkContentId, 'open')}>{getLabel(360, '打开')}</Button> : null
                    }
                    {
                      con.canEdit && con.canEdit == 1 && con.itemsVO.status == '1' ?
                        <Button className="cowork-content-detail-btn" onClick={this.operateCoworkItem.bind(this, coworkContentId, 'end')}>{getLabel(405, '结束')}</Button> : null
                    }
                    <Button onClick={() => {this.showLogDialog(true)}} className="cowork-content-detail-btn">{getLabel(17480, '查看日志')}</Button>
                    <a href={con && con.exportUrl} target="_blank">
                      <Button className="cowork-content-detail-btn">{`${getLabel(17416,'导出')}${getLabel(15153,'相关交流')}`}</Button>
                    </a>
                  </div>
                </div>

                <div style={{height: '100%', paddingBottom: 95}}>
                  <WeaNewScroll ref="scroll" toTop={tabKey == 'list'} height={'100%'} onScroll={this.handleScroll}>
                    <Detail content={content} labelList={labelList}
                            markItemAsType={markItemAsType}
                            deleteCoworkLabels={deleteCoworkLabels}
                            // operateCoworkItem={operateCoworkItem}
                    />
                    <div className="greyDiv" style={{height: 10}}/>
                    {canReply && [
                      <div className='cowork-grey-submit' style={edit ? {} : {display: 'none'}}>
                        <CoworkRichText ref="richText" hasSubmit={true} submit={this.submitInEdit} cancel={this.cancel}
                                        approvalStatus={itemsVO.approvalAtatus}
                                        isCanAnonymous={itemsVO.isAnonymous}
                                        isApproval={itemsVO.isApproval}
                                        isCoworkTypeApprove={con.isCoworkTypeApprove}
                                        editType="discuss"/>

                      </div>,
                      edit || (
                        <div className='cowork-content-msg wea-f12' onClick={() => {
                          // this.setState({edit: true}, () => {
                          //   this.refs.richText && this.refs.richText.wrappedInstance.focus();
                          // });
                          this.props.coworkMainStore.setDetailParams({edit: true},
                            () => this.refs.richText && this.refs.richText.wrappedInstance.focus());
                        }}>
                          <b></b>
                          <em className='icon-coms-edit'></em>
                          <span>{getLabel(389454, '请填写交流内容')}</span>
                        </div>
                      ),
                      <div className="greyDiv" style={{height: 10}}/>
                    ]}
                    <div className="wea-cowork-content-list">
                      <WeaTab
                        datas={[
                          {title: getLabel(15153, '相关交流'), key: 'list'},
                          {
                            titleText: getLabel(32572, '与我相关'),
                            title: (<div className="cowork-my" onClick={this.dotClick}>{getLabel(32572, '与我相关')}
                              <span className={con && con.isRead == '1' ? "cowork-my-dot" : "cowork-my-dotHide"}></span></div>), key: 'my'
                          },
                          {title: getLabel(83274, '参与情况'), key: 'stat'},
                          {title: getLabel(84399, '相关资源'), key: 'resource'},
                        ]}
                        size="small"
                        keyParam='key'
                        leftStyle={{width: '44%'}}
                        rightStyle={{width: '56%'}}
                        selectedKey={tabKey}
                        onChange={this.changeTabKey}
                        searchType={tabKey == 'list' ? "base,advanced" : ""}
                        buttons={tabKey == 'list' && con.canEdit == 1 ? [
                          <span>
                        <span className={'batch-oper-button icon-cooperation-BatchOperation ' + (batchOperate && 'cur')}
                              title={getLabel(31914, '批量操作')}
                              onClick={coworkMainStore.setBatchOperate}/>
                            {con.canApproval == 1 && <span className={'batch-oper-button icon-cooperation-PendingApproval ' + (pendApprove && 'cur')}
                                                           title={getLabel(2242, '待审批')}
                                                           onClick={coworkMainStore.setPendApprove}/>}
                      </span>
                        ] : []}
                        onSearch={this.baseSearch}
                        searchsBaseValue={srchcontent}
                        // onSearchChange={this.onSearchChange}
                        onSearchChange={v => coworkMainStore.content.searchForm.updateFields({srchcontent: v})}
                        showSearchAd={showSearchAd}
                        setShowSearchAd={this.setShowSearchAd}
                        hasMask={false}
                        searchsAd={<SearchForm conditioninfo={conditioninfo}
                                               form={coworkMainStore.content.searchForm}
                                               initFunc={(searchForm) => this.searchForm = searchForm}/>}
                        buttonsAd={[
                          (<Button type="primary" onClick={this.search}>{getLabel(197, '搜索')}</Button>),
                          (<Button type="ghost" onClick={this.resetSearch}>{getLabel(2022, '重置')}</Button>),
                          (<Button type="ghost" onClick={this.setShowSearchAd.bind(this, false)}>{getLabel(201, '取消')}</Button>)
                        ]}
                      />
                      <div className="tabContent">
                        {
                          tabKey == 'list' ? <ReplyList batchOperate={batchOperate} ref="replyList" submit={this.submit}
                                                        isCanAnonymous={itemsVO.isAnonymous} canReply={canReply}
                                                        coworkId={coworkContentId} scrollToTop={this.scrollToTop}/> :
                            tabKey == 'my' ?   <MyReplyList ref="my" submit={this.submit} coworkId={coworkContentId}
                                                            scrollToTop={this.scrollToTop} canReply={canReply}
                                                            isCanAnonymous={itemsVO.isAnonymous} /> :
                              tabKey == 'stat' ? <Stat coworkId={coworkContentId}/> :
                                <Resource coworkId={coworkContentId}/>
                        }
                      </div>
                    </div>
                  </WeaNewScroll>
                </div>
              </div>,

              (tabKey == 'list' || tabKey == 'my') &&
              <div className="fixPagination">
                {tabKey == 'list' && batchOperate && (
                  <div className="fix-front">
                    <WeaCheckbox onChange={coworkMainStore.checkAll} value={checkAll}/>
                    <span className="ml5">{getLabel(556, '全选')}</span>
                    <Button type="primary" className="ml20" onClick={this.batchDelete}>{getLabel(32136, '批量删除')}</Button>
                    {pendApprove && <Button type="primary" className="ml10" onClick={this.batchApprove}>{getLabel(83212, '批量批准')}</Button>}
                  </div>
                )}
                <Pagination {...page} showQuickJumper={true} onChange={this.changePage}/>
              </div>,
              <CoworkFloorDialog ref="floor"/>
            ]
          ) : <WeaAlertPage><div>{getLabel(382663,'暂无权限')}</div></WeaAlertPage>
        )}
        <NewCowork storeMapKey={storeMapKey}/>
        <LogDialog visible={this.state.visiable} id={coworkContentId} showLogDialog={(bool) => this.showLogDialog(bool)}/>
      </div>
    )
  }

  //编辑
  edit = () => {
    //storeMapKey通过Detail页面传进来
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(storeMapKey);
    coworkNewStore.doEditInit();
  }

  //查看日志
  showLogDialog = (bool) => {
    this.setState({
      visiable: bool
    })
  }

  operateCoworkItem = (id, type) => {
    let {operateCoworkItem} = this.props.coworkMainStore;
    if (type == 'end') {
      Modal.confirm({
        content: getLabel(4910, '确认要结束该协作吗?','note'),
        onOk() {
          operateCoworkItem && operateCoworkItem(id, type);
        }
      });
    } else {
      operateCoworkItem && operateCoworkItem(id, type);
    }
  }
  
  //红点显示隐藏
  dotClick = () => {
    this.props.coworkMainStore.setCoworkRead();
  }
  
  setShowSearchAd = (bool) => {
    // this.setState({
    //   showSearchAd: bool
    // });
    this.props.coworkMainStore.setDetailParams({showSearchAd: bool})
  }

  changeTabKey = (tabKey) => {
    // this.setState({
    //   tabKey: tabKey
    // });
    this.props.coworkMainStore.setDetailParams({tabKey: tabKey});
  }

  changePage = (current) => {
    // let {tabKey} = this.state;
    const {tabKey} = this.props.coworkMainStore.detailParams;
    if (tabKey == 'list') {
      this.refs.replyList && this.refs.replyList.wrappedInstance.changePage(current);
    } else {
      this.refs.my && this.refs.my.wrappedInstance.changePage(current);
    }
  }
  
  submitInEdit= (params, callback) => {
    return this.submit(params, this.cancel.bind(this, () => {
      isFunction(callback) && callback();
      this.changeTabKey("list");
    }));
  }
  
  submit = (params, callback) => {
    if (!params.remark) {
      message.error(getLabel(382648, '请输入交流内容'));
      return false;
    }
    const {coworkMainStore} = this.props;
    // const {tabKey} = this.state;
    const {tabKey} = coworkMainStore.detailParams;
    return coworkMainStore.submitCoworkDiscuss(params, tabKey, callback);
  }
  
  cancel = (callback) => {
    this.refs.richText.wrappedInstance.clear();
    // this.setState({
    //   edit: false
    // });
    this.props.coworkMainStore.setDetailParams({edit: false});
    isFunction(callback) && callback();
  }
  
  batchDelete = () => {
    let that = this;
    const {coworkMainStore} = this.props;
    let checkIds = coworkMainStore.content.checkIds;
    if (checkIds && checkIds.length > 0) {
      Modal.confirm({
        content: (
          <div className="wea-list-confirm">
            <p>{getLabel(4912, '确认要删除这些讨论记录吗?','note')}</p>
            <div className="list-confirm-text"><WeaCheckbox onChange={this.valueChange} value={that.state.value}/>{getLabel(4828, '同时删除该帖子的所有评论?','note')}</div>
          </div>
        ),
        onOk() {
          let {value} = that.state;
          coworkMainStore.batchDelete(value);
        }
      });
    } else {
      message.info(getLabel(84534, '请先选择要删除的记录'));
    }
  }

  valueChange = (value) => {
    this.setState({
      value: value
    });
  }
  
  batchApprove = () => {
    const {coworkMainStore} = this.props;
    let checkIds = coworkMainStore.content.checkIds;
    if (checkIds && checkIds.length > 0) {
      coworkMainStore.batchApprove();
    } else {
      message.info(getLabel(4913, '请先选择要批准的记录?','note'));
    }
  }
  
  setPendApprove = () => {
    const {coworkMainStore} = this.props;
    coworkMainStore.setPendApprove();
  }
  
  baseSearch = (value) => {
    const {coworkMainStore} = this.props;
    coworkMainStore.searchDiscussList({srchcontent: value});
    this.setShowSearchAd(false);
  }

  search = () => {
    const {coworkMainStore} = this.props, searchForm = coworkMainStore.content.searchForm;
    coworkMainStore.searchDiscussList(searchForm.getFormParams());
    this.setShowSearchAd(false);
  }

  resetSearch = () => {
    this.searchForm.clear();
  }
  
  onKeyDown = (e) => {
    if (e.altKey && e.keyCode == 71) {
      this.refs.floor.wrappedInstance.open();
    }
  }

  scrollToTop = () => {
    this.refs.scroll && this.refs.scroll.scrollerToTop();
  }
}

export default CoworkContent;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/content/index.js